var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wi100 hi100",attrs:{"id":"newsList"}},[(_vm.newsList.length > 0)?_c('dv-scroll-board',{staticStyle:{"padding":"0px"},attrs:{"config":_vm.dataConfig}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }